import { http } from '@/api/http';

import type { PersonDto } from '@/features/patient-record/api';

/**
 * Wire body for `POST /fhir/patients`.
 *
 * `mrn` is required (`@NotBlank` on the backend). `user.id` is required
 * only when `fhirLauncher.authorizationCriteria === 'REFRESH_TOKEN'`;
 * we auto-fill it from the current session on every call so the FE
 * never has to know which strategy is active.
 *
 * MRN is PHI — it MUST stay in the JSON body. Never place it in a query
 * string, `console.log`, or an ApiError message.
 */
export interface FhirPatientRequestBody {
  readonly mrn: string;
  readonly user?: { readonly id: string };
}

export const fhirLauncherEndpoints = {
  /**
   * POST /fhir/patients — search the configured external FHIR server by
   * MRN, upsert the local Person, return the upserted PersonDTO.
   *
   * Status codes handled by the caller:
   *   200 unique match → PersonDto
   *   404 no match
   *   300 multiple matches (not unique)
   *   422 could not save
   *   503 downstream FHIR/token service unavailable
   *   400 FHIR base URL not configured
   */
  importPatient: (
    body: FhirPatientRequestBody,
    options?: { signal?: AbortSignal },
  ): Promise<PersonDto> => http.post<PersonDto>('/fhir/patients', body, options),
};
